import * as React from 'react';
export const amexSvg = React.forwardRef(function amexSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6EBF1',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Zm-1 0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#007DC3',
        d: 'm13.985 6.651-1.144 1.45 1.112 1.48h-.726l-.785-.963-.778.963H8.94v-2.93h2.82l.708.952.76-.952h.757ZM9.546 7.764h1.437v.594H9.546v.63h1.437v.425l1.066-1.337-1.066-1.33v.499H9.546v.52-.001Zm-1.15-1.113v2.93H7.79V7.232l-.866 2.35h-.572L5.49 7.195V9.58H4.252l-.244-.667h-1.27l-.222.667H1.85l1.086-2.93h.926l1.021 2.842V6.65h.989l.795 1.966.744-1.966h.986Zm-5.46 1.67h.862l-.415-1.188-.447 1.187Zm9.919-2.247-.369.462-.339-.457A.197.197 0 0 0 11.989 6H7.096a.196.196 0 0 0-.183.127l-.266.702-.286-.707A.197.197 0 0 0 6.18 6H2.62a.197.197 0 0 0-.185.128l-1.423 3.84a.196.196 0 0 0 .184.265h1.649c.085 0 .16-.054.186-.135l.177-.534h.345l.197.54a.196.196 0 0 0 .184.129h7.947a.2.2 0 0 0 .154-.073l.41-.508.414.508a.198.198 0 0 0 .152.073h1.626a.31.31 0 0 0 .247-.496l-1.22-1.626 1.269-1.61a.31.31 0 0 0-.244-.5h-1.68a.195.195 0 0 0-.154.073Z',
      }),
    ),
  );
});
amexSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var amex = {
  category: 'card',
  colorable: false,
  name: 'amex',
  svg: amexSvg,
};
